/* SS · Nuestro criterio — revelado suave.
   IntersectionObserver y nada mas: sin rAF, sin listeners de scroll, sin
   temporizadores y sin librerias. El estado oculto solo existe si el motor
   esta presente y sano; ante la menor duda la seccion se queda visible.
   Mismo modelo de seguridad que ss-favoritos.js. */
(function () {
  'use strict';
  /* Sin IntersectionObserver no se arma nada. */
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init(el) {
    if (el.__sscr) return;
    el.__sscr = true;

    var io = null;
    var onVis = null;

    function cleanup() {
      if (io) { io.disconnect(); io = null; }
      if (onVis) { document.removeEventListener('visibilitychange', onVis); onVis = null; }
    }

    function reveal() {
      cleanup();
      el.setAttribute('data-sscr-in', '');
    }

    /* Dentro del viewport o a menos de un cuarto de pantalla de el. */
    function cerca() {
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      return r.top < h * 1.25 && r.bottom > h * -0.25;
    }

    try {
      /* El observador se construye ANTES de ocultar nada: si el constructor
         falla, no llega a existir un estado oculto que rescatar. */
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { reveal(); return; }
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      el.setAttribute('data-sscr-armed', '');
      io.observe(el);

      /* Cinturon: si la pestana estuvo oculta y vuelve con la seccion ya a la
         vista, se revela sin esperar al siguiente fotograma. Es texto: no
         puede quedarse invisible. */
      onVis = function () {
        if (document.visibilityState !== 'visible') return;
        if (cerca()) reveal();
      };
      document.addEventListener('visibilitychange', onVis);
    } catch (e) {
      cleanup();
      el.removeAttribute('data-sscr-armed');
    }
  }

  function boot() {
    var list = document.querySelectorAll('[data-sscr]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();